import "react-slidedown/lib/slidedown.css";
import "react-toastify/dist/ReactToastify.css";

import { useLocationChange, usePath, useRedirect, useRoutes } from "raviger";
import { Fragment, useEffect, useMemo, useState } from "react";

import generatedGitInfo from './generatedGitInfo.json';

import Helmet from "react-helmet";
import { ToastContainer } from "react-toastify";

import useConfig from "core/custom-hooks/useConfig";
import useMobileAppEvents from "core/custom-hooks/useMobileAppEvents";
import useProtectRoutes from "core/custom-hooks/useProtectRoutes";
import useRefreshToken from "core/custom-hooks/useRefreshToken";
import useScript from "core/custom-hooks/useScript";
import useSettings from "core/custom-hooks/useSettings";
import useStore from "core/custom-hooks/useStore";
import useT from "core/custom-hooks/useT";

import ModalLoader from "react-spinners/PuffLoader";

import MishOrdersPinger from "components/MishOrdersPinger";
import Recaptcha from "components/Recaptcha/Recaptcha";
import { siteBaseUrl } from "core/common/constants/env";

import * as Utils from "core/common/utils";
import { inSecureRoutes, isPreAuthenticationPath, routesPay2000, secureRoutes } from "core/route/";
import { setIsIPhone, setIsMobile, setTzurPopup, setTzurPopupCenter } from "core/store/actionCreators";
import CustomerPopNotActive from "components/Popup/PopupNotActive";
import { openPopup } from "components/Popup/Popup";
import LoginPage from "pages/Auth/Login/LoginPage";
import Layout from "./hoc/Layout/Layout";
import LayoutWithoutSideBar from "./hoc/Layout/LayoutWithoutSideBar";

import useAxiosInterceptors from './repositories/clients/useAxiosInterceptors';
import { trySetReturnUrl } from "core/route";


const LAYOUT_WITH_SIDEMENU = "full-layout";
const LAYOUT_WITHOUT_SIDEMENU = "simple-layout";
const CLIP_LOADER_COLOR = "#5866F5";

const App = () => {

    useAxiosInterceptors();
        
    useMobileAppEvents();

    useRedirect("/", "/home");

    useRefreshToken(true);

    const { handleRouteChange } = useProtectRoutes();
    useLocationChange(handleRouteChange, { onInitial: true });

    const [ready, setReady] = useState(false);

    const { ready: T } = useT();
    const { ready: S } = useSettings();
    const { ready: C } = useConfig();

    const hasToken = Utils.HasRefreshToken();
    const currentRoute = usePath();
    useEffect(() => {
        trySetReturnUrl(currentRoute);
    }, [currentRoute]);

    const { dispatch, state } = useStore();
    const { business, settings, isModalLoading } = state

    const pay2000 = !(business?.stats_media_platforms?.length === 1 && business?.stats_media_platforms?.includes('ZAPGROUPSITES'));
    //#region Hooks

    useScript(
        "https://www.sc.pages06.net/lp/static/js/iMAWebCookie.js?4687ab3b-16e8cdded0f-b292eee3e12767e0c1a23a3c31e9c522&h=www.pages06.net"
    );
    window.addEventListener("message", (event) => {
        if (event.data && event.data.action === 'PPA_BOUNCE_REDIRECT') {
            var targetUrl = event.data.url;

            var currentParentUrl = window.location.href;

            var separator = targetUrl.includes('?') ? '&' : '?';

            var finalUrl = targetUrl + separator + "returnToHost=" + encodeURIComponent(currentParentUrl);

            console.log("Bouncing to:", finalUrl);

            window.location.href = finalUrl;
        }
    }, false);
    useEffect(() => {
        dispatch(setIsMobile(Utils.isMobile()));

        const handleResize = () => dispatch(setIsMobile(window.innerWidth <= Utils.mobileMaxWidth));

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [dispatch]);

    useEffect(() => {
        const userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;

        if (/iPhone/i.test(userAgent)) {
            dispatch(setIsIPhone(true));
        }
    }, []);

    useEffect(() => {

        if (Utils.HasAccessToken()) {
            setReady(T && S && C);
            console.debug("ready for authorized");
        } else {
            setReady(T && S);
            console.debug("ready for login");
        }

        // eslint-disable-next-line 
    }, [T, S, C]);

    useEffect(() => {
        dispatch(setTzurPopup({ isOpen: false }))
        dispatch(setTzurPopupCenter({ isOpen: false }));
    }, [window.location.pathname]);

    useEffect(() => {
        if (business && isRRH && isActive) {
            notActivePopup();
        }
    }, [business]);
    //#endregion

    const layout = useMemo(() => {

        var insecureRoute = isPreAuthenticationPath(currentRoute);

        const layout = insecureRoute || currentRoute === "/admin-account-selection" ?
            LAYOUT_WITHOUT_SIDEMENU :
            LAYOUT_WITH_SIDEMENU

        console.debug("app init: Layout", layout);

        return layout;

        // eslint-disable-next-line 
    }, [currentRoute]);

    const routes = useMemo(() => {

        console.debug("app init: Layout", layout);

        let secureRoutesInit = pay2000 ? { ...secureRoutes, ...routesPay2000 } : secureRoutes

        return hasToken ? secureRoutesInit : inSecureRoutes;

        // eslint-disable-next-line 
    }, [hasToken, business]);

    const route = useRoutes(routes) || <LoginPage />;
    const isBusinessEmpty = business == null || business === 'undefined' || Object.keys(business).length === 0;
    const isActive = (isBusinessEmpty || business.is_active);
    const isRRH = (business?.cust_status_type === 'רר\"ח');


    const notActivePopup = () => {
        if (isRRH) openCustomerNotActivePopup('ררח');
    }

    const openCustomerNotActivePopup = (type) => {    
        openPopup(dispatch, <CustomerPopNotActive type={type} />);
    };
	
    return (
        <Fragment>
            <Helmet>
                <meta name="com.silverpop.brandeddomains" content={`www.pages06.net,${siteBaseUrl}`} />
                <meta name="branch" content={generatedGitInfo.gitBranch} />
                <meta name="commit" content={generatedGitInfo.gitCommitHash} />
                <meta name="commit-date" content={generatedGitInfo.gitCommitHashDate} />
            </Helmet>
            <div>

                {isModalLoading &&
                    // Modal loader. Blocks the whole screen while working!.
                    <div className="loader_container">
                        <ModalLoader
                            loading={true}
                            color={CLIP_LOADER_COLOR}
                            size={200} />
                    </div>
                }

                <MishOrdersPinger />

                <ToastContainer rtl />

                {ready && layout === LAYOUT_WITHOUT_SIDEMENU &&
                    <LayoutWithoutSideBar isActive={ isActive} isRRH={isRRH}>{route}</LayoutWithoutSideBar>
                }

                {ready && layout === LAYOUT_WITH_SIDEMENU &&
                    <Layout isActive={isActive} isRRH={isRRH}>{route}</Layout>
                }

                {ready && settings.recaptureEnabled && <Recaptcha />}
            </div>
        </Fragment>
    );
}

export default App;